import { render, staticRenderFns } from "./business-list.vue?vue&type=template&id=63f870e1&scoped=true&"
import script from "./business-list.vue?vue&type=script&lang=js&"
export * from "./business-list.vue?vue&type=script&lang=js&"
import style0 from "./business-list.vue?vue&type=style&index=0&id=63f870e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f870e1",
  null
  
)

export default component.exports